import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';

import { FilterValuesObj } from '../../../features/filter/interfaces';
import { FilterValueKey } from '../../../features/filter/utils';

interface IURLParams {
  filtersValue: FilterValuesObj;
}

const useURLParams = () => {
  const [, setParams] = useSearchParams();
  const { filtersValue } = useAppSelector((state) => state.filter);

  useEffect(() => {
    if (Object.keys(filtersValue).length !== 0) {
      setParams({
        calculationResult: `${filtersValue[FilterValueKey.CALCULATION_RESULT]}`,
        supplyPressure: `${filtersValue[FilterValueKey.SUPPLY_PRESSURE]}`,
        outputPressure: `${filtersValue[FilterValueKey.OUTPUT_PRESSURE]}`,
        tubingLength: `${filtersValue[FilterValueKey.TUBING_LENGTH]}`,
        internalDiameter: `${filtersValue[FilterValueKey.INTERNAL_DIAMETER]}`,
        discharge: `${filtersValue[FilterValueKey.DISCHARGE]}`,
      });
    }
  }, [filtersValue, setParams]);
};

export default useURLParams;
